export default () => ({
    '& .ant-upload-list-picture-card-container': {
        display: 'none',
    },
    '& .ant-upload.ant-upload-select-picture-card': {
        width: '100%',
        height: '5rem',
        margin: '1rem 0',
    },
});
